import { createTheme } from '@mui/material/styles';

// Import fonts
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
      light: '#42a5f5',
      dark: '#1565c0',
    },
    secondary: {
      main: '#9c27b0',
      light: '#ba68c8',
      dark: '#7b1fa2',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      'Poppins',
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontFamily: 'Poppins, Roboto, sans-serif',
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontFamily: 'Poppins, Roboto, sans-serif',
      fontSize: '2rem',
      fontWeight: 500,
    },
    h3: {
      fontFamily: 'Poppins, Roboto, sans-serif',
      fontSize: '1.75rem',
      fontWeight: 500,
    },
    h4: {
      fontFamily: 'Poppins, Roboto, sans-serif',
      fontSize: '1.5rem',
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'Poppins, Roboto, sans-serif',
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    h6: {
      fontFamily: 'Poppins, Roboto, sans-serif',
      fontSize: '1rem',
      fontWeight: 500,
    },
    subtitle1: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
    },
    subtitle2: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 500,
    },
    body1: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
    },
    body2: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '0.875rem',
      fontWeight: 400,
    },
    button: {
      fontFamily: 'Roboto, sans-serif',
      textTransform: 'none',
      fontWeight: 500,
    },
    caption: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 400,
    },
    overline: {
      fontFamily: 'Roboto, sans-serif',
      fontSize: '0.75rem',
      fontWeight: 400,
      textTransform: 'uppercase',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

export default theme;
